import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BrowserView, MobileView } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages, faCamera } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
import Lightbox from 'lightbox-react';
import { listImages } from './imagesFromAssets';
import { useImage } from '../../services/Image/useImage';
import Translate, { t } from '../common/Translate';
import 'lightbox-react/style.css';

function Image(props) {
  const { elementIds, question, goNextQuestion } = props;
  const { formId, sectionId, questionId } = elementIds;
  const { id: questionImageId, type: questionImageType } = question;
  const sectionsImageModel = ['car_pictures', 'motor', 'road_test', 'body'];
  const { setDisableNav } = props;
  const [image, setImage] = useImage(
    formId,
    `inspection.children.${sectionId}.children.${questionId}.value.id`,
    questionImageId,
    questionImageType,
  );
  const [popedUp, setPopup] = useState(false);

  const handleAddImage = (e) => {
    const img = e.target.files[0];
    setImage(img);
    if (goNextQuestion) goNextQuestion();
  };

  useEffect(() => {
    if (setDisableNav !== undefined) {
      if (image !== null && image !== '' && image !== undefined) setDisableNav(false);
      else setDisableNav(true);
    }
  });

  const srcModel = listImages[questionId];
  const classModel = image ? 'invisible img-model' : 'img-model';

  const togglePopup = () => {
    setPopup(!popedUp);
  };

  if (image) {
    return (
      <>
        <div className="question-image" data-cy={questionId}>
          {popedUp && <Lightbox mainSrc={image} onCloseRequest={togglePopup} />}
          <MobileView>
            <div className="text-center">
              <img
                src={image}
                className="single-image-mobile"
                alt=""
                onClick={() => togglePopup(image)}
                aria-hidden="true"
              />
            </div>
            <div className="text-center">
              <label htmlFor={`upload_camera${question.id}`} className="link-camera">
                <div className="btn btn-link">
                  <Translate code="redo" />
                </div>
                <input
                  id={`upload_camera${question.id}`}
                  type="file"
                  question={question}
                  accept="image/*"
                  onChange={handleAddImage}
                  data-cy="upload_camera"
                />
              </label>
            </div>
          </MobileView>
          <BrowserView>
            <div>
              <img src={image} className="w-25" alt="" onClick={() => togglePopup(image)} aria-hidden="true" />
              <label htmlFor={`change_image${question.id}`} className=" text-left">
                <div className="btn btn-link pl-0">{t('changeImage')}</div>
                <input
                  id={`change_image${question.id}`}
                  type="file"
                  className="d-none"
                  question={question}
                  accept="image/*"
                  capture="camera"
                  onChange={handleAddImage}
                  data-cy="change_image"
                />
              </label>
            </div>
          </BrowserView>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="question-image">
        <MobileView>
          <div id="car-pictures">
            <div id="image-model">
              {(sectionsImageModel.includes(sectionId) || srcModel) && (
                <Col>
                  <Row>
                    <p className="text-model">
                      <i>
                        <Translate code="car_pictures_text_model" />
                      </i>
                    </p>
                  </Row>
                  <Row>
                    <img src={srcModel} className={classModel} alt="ss" />
                  </Row>
                </Col>
              )}
            </div>

            <div id="upload-image-btn">
              <Row>
                <Col className="text-center">
                  <label htmlFor="upload_gallery" className="button-camera circle">
                    <FontAwesomeIcon icon={faImages} />
                    <input
                      type="file"
                      id="upload_gallery"
                      accept="image/*"
                      onChange={handleAddImage}
                      data-cy="upload_gallery"
                    />
                  </label>
                  <Translate code="photo_gallery" />
                </Col>
                <Col className="text-center">
                  <label htmlFor="upload_camera" className="button-camera circle">
                    <FontAwesomeIcon icon={faCamera} />
                    <input
                      type="file"
                      id="upload_camera"
                      accept="image/*"
                      capture
                      onChange={handleAddImage}
                      data-cy="upload_camera"
                    />
                  </label>
                  <Translate code="camera" />
                </Col>
              </Row>
            </div>
          </div>
        </MobileView>
        <BrowserView>
          <div>
            <label htmlFor={`add_image${question.id}`} className="button-camera circle d-inline-block">
              <FontAwesomeIcon icon={faImages} />
              <input
                id={`add_image${question.id}`}
                type="file"
                className="d-none"
                question={question}
                accept="image/*"
                onChange={handleAddImage}
                data-cy="add_image"
              />
            </label>
            <div>
              <Translate code="photo_gallery" />
            </div>
          </div>
        </BrowserView>
      </div>
    </>
  );
}

export default Image;
Image.propTypes = {
  setDisableNav: PropTypes.func,
  goNextQuestion: PropTypes.func,
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.shape(),
    type: PropTypes.oneOf(['image']).isRequired,
  }).isRequired,
  elementIds: PropTypes.shape({
    questionId: PropTypes.string.isRequired,
    sectionId: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
  }).isRequired,
};

Image.defaultProps = {
  setDisableNav: undefined,
  goNextQuestion: undefined,
};
